import Delegate from "ftdomdelegate";

import ProductVariants from "../components/product-variants";
import Image from "../tools/image";

export default class FeaturedProductSection {
  constructor(container) {
    this.element = container;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (
      !this.options["usePlaceholder"] &&
      this.options["templateSuffix"] !== "coming-soon"
    ) {
      this.productVariants = new ProductVariants(container, this.options);
    }

    this._attachListeners();
  }

  onUnload() {
    this.delegateElement.off("click");

    if (this.productVariants) {
      this.productVariants.destroy();
    }
  }

  _attachListeners() {
    this.delegateElement.on(
      "variant:changed",
      this._updateMainImage.bind(this)
    );
  }

  /**
   * Update the main featured image
   */

  _updateMainImage(event) {
    var variant = event.detail.variant,
      previousVariant = event.detail.previousVariant;

    if (
      !variant ||
      !variant["featured_image"] ||
      (previousVariant["featured_image"] &&
        previousVariant["featured_image"]["id"] ===
          variant["featured_image"]["id"])
    ) {
      return;
    }

    // Otherwise we are on the home page. It's a bit more complex as we have to rewrite some code normally written in Liquid
    var newImage = variant["featured_image"];

    var mainImageContainer = this.element.querySelector(
      ".featuredProduct__gallery .aspectRatio"
    );
    mainImageContainer.style.cssText =
      "max-width: " +
      newImage["width"] +
      "px; --aspect-ratio: " +
      newImage["width"] / newImage["height"];

    var newImageElement = document.createElement("img");
    newImageElement.classList.add("image--lazyLoad");
    newImageElement.setAttribute(
      "data-src",
      Image.getSizedImageUrl(newImage["src"], "1x1").replace(
        "_1x1.",
        "_{width}x."
      )
    );
    newImageElement.setAttribute(
      "data-widths",
      "[" +
        Image.getSupportedSizes(
          newImage,
          [200, 400, 600, 700, 800, 900, 1000]
        ).join(",") +
        "]"
    );
    newImageElement.setAttribute("data-sizes", "auto");

    mainImageContainer.replaceChild(
      newImageElement,
      mainImageContainer.querySelector("img")
    );
  }
}
